import { z } from 'zod';
export const aiProviderIdSchema = z.enum([
    'yandex',
    'deepseek',
    'openai',
    'anthropic',
    'openrouter',
    'openai_compatible',
    'remote_runner',
]);
export const aiModelRefSchema = z.object({
    provider: aiProviderIdSchema,
    model: z.string().min(1).max(128),
    /** Selects a concrete named connection when a provider has more than one. */
    connectionId: z.string().min(1).max(128).optional(),
});
export const aiRoleRuntimeConfigSchema = z.object({
    roleKey: z.string().min(1).max(64),
    primary: aiModelRefSchema,
    fallback: aiModelRefSchema.nullable(),
    timeoutMs: z.number().int().positive().max(120000),
    maxOutputTokens: z.number().int().positive().max(16000),
    promptVersion: z.number().int().positive(),
    configVersion: z.number().int().positive().optional(),
});
export const aiRuntimeErrorCodeSchema = z.enum([
    'ai_role_unconfigured',
    'ai_provider_unavailable',
    'ai_provider_timeout',
    'ai_transcription_unavailable',
    'invalid_audio',
    'ai_config_invalid',
    'ai_secrets_unavailable',
]);
;
export class AiRuntimeError extends Error {
    constructor(code, message) {
        super(message ?? code);
        this.code = code;
        this.name = 'AiRuntimeError';
    }
}
//# sourceMappingURL=runtime.js.map